/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface IngressAPICreateIngressBody {
  ingress?: MinioIngressDetails;
}

export interface IngressAPIUpdateIngressBody {
  ingress?: MinioIngressDetails;
}

export interface GooglerpcStatus {
  /** @format int32 */
  code?: number;
  message?: string;
  details?: ProtobufAny[];
}

export type MinioEmpty = object;

export interface MinioHTTPIngressPath {
  path?: string;
  pathType?: string;
  backend?: MinioIngressBackend;
}

export interface MinioIngress {
  id?: string;
  name?: string;
  namespace?: string;
  /** @format int64 */
  sysCreated?: string;
}

export interface MinioIngressBackend {
  serviceName?: string;
  /** @format int32 */
  servicePort?: number;
}

export interface MinioIngressDetails {
  metadata?: MinioObjectMeta;
  spec?: MinioIngressSpec;
  status?: MinioIngressStatus[];
}

export interface MinioIngressList {
  items?: MinioIngressDetails[];
}

export interface MinioIngressPortStatus {
  /** @format int32 */
  port?: number;
  protocol?: string;
  error?: string;
}

export interface MinioIngressRule {
  host?: string;
  http?: MinioHTTPIngressPath[];
}

export interface MinioIngressSpec {
  rules?: MinioIngressRule[];
  tls?: MinioIngressTLS[];
}

export interface MinioIngressStatus {
  ip?: string;
  hostname?: string;
  ports?: MinioIngressPortStatus[];
}

export interface MinioIngressTLS {
  hosts?: string[];
  secretName?: string;
}

export interface MinioObjectMeta {
  name?: string;
  namespace?: string;
  uuid?: string;
  labels?: Record<string, string>;
  annotations?: Record<string, string>;
}

export interface ProtobufAny {
  "@type"?: string;
  [key: string]: any;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title ingress.proto
 * @version version not set
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags IngressAPI
     * @name ListIngresses
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/ingresses
     */
    listIngresses: (
      siteId: string,
      namespace: string,
      query?: {
        resourceID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MinioIngressList, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/ingresses`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags IngressAPI
     * @name CreateIngress
     * @request POST:/api/v2/sites/{siteID}/namespaces/{namespace}/ingresses
     */
    createIngress: (
      siteId: string,
      namespace: string,
      body: IngressAPICreateIngressBody,
      params: RequestParams = {},
    ) =>
      this.request<MinioIngress, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/ingresses`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags IngressAPI
     * @name GetIngress
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/ingresses/{resourceID}
     */
    getIngress: (
      siteId: string,
      namespace: string,
      resourceId: string,
      params: RequestParams = {},
    ) =>
      this.request<MinioIngressDetails, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/ingresses/${resourceId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags IngressAPI
     * @name DeleteIngress
     * @request DELETE:/api/v2/sites/{siteID}/namespaces/{namespace}/ingresses/{resourceID}
     */
    deleteIngress: (
      siteId: string,
      namespace: string,
      resourceId: string,
      params: RequestParams = {},
    ) =>
      this.request<MinioEmpty, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/ingresses/${resourceId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags IngressAPI
     * @name UpdateIngress
     * @request PUT:/api/v2/sites/{siteID}/namespaces/{namespace}/ingresses/{resourceID}
     */
    updateIngress: (
      siteId: string,
      namespace: string,
      resourceId: string,
      body: IngressAPIUpdateIngressBody,
      params: RequestParams = {},
    ) =>
      this.request<MinioIngress, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/ingresses/${resourceId}`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
